/* eslint-disable array-callback-return */
/* eslint-disable no-mixed-operators */
import * as React from 'react';
import { IDetailsListProps, IColumn, ConstrainMode, SelectionMode } from '@fluentui/react/lib/DetailsList';
import { connect } from 'react-redux';
import { showDialog, showToastMessage } from '../../Dialog/actions';
import { IUserProfile } from '../../Auth/types';
import Helper from '../../../core/libraries/Helper';
import RbLabel, { LabelSize } from '../../../bosch-react/components/label/RbLabel';
import ListActionsMenu from '../../../core/common/ListActionsMenu';
import Constants from '../../../core/libraries/Constants';
import { RootState } from '../../../store/store';
import { ICancelRequest, IAccountReport } from '../types';
import DetailsListWrapper from '../../../core/components/DetailsListWrapper/DetailsListWrapper';
import { DirectionalHint, IListProps, Link, Panel, ShimmeredDetailsList, TooltipHost } from '@fluentui/react';
import Configuration from '../../../core/libraries/Configuration';
import ChangeWorkflowIdDialog from '../../../core/common/ChangeWorkflowIdDialog';
import CancelReasonDialog from '../../../core/common/CancelReasonDialog';
import { cancelWorkflow, getPendingUploads, updateWorkflowID } from '../services';
import Template from '../../../core/libraries/Template';
import RbButton, { ButtonSize, ButtonType } from '../../../bosch-react/components/button/RbButton';
import _ from 'lodash';
import RbTextField from '../../../bosch-react/components/text-field/RbTextField';
import RbDivider from '../../../bosch-react/components/divider/RbDivider';

interface MyPendingReportsProps {
    userProfile: IUserProfile | undefined,
    showDialog: typeof showDialog,
    showToastMessage: typeof showToastMessage,
}

interface IState {
    isAdminMode: boolean,
    pendingReports: IAccountReport[] | null,
    filteredItems: IAccountReport[] | null,
    selectedItem: any,
    showCancelDialog: boolean,
    showWorkflowIdDialog: boolean,
    columns: IColumn[],
    isShowUpdateWorkflowIdDialog: boolean,
}

class MyPendingReports extends React.Component<MyPendingReportsProps, IState> {
    private timeoutId: NodeJS.Timeout | null = null;
    private newWorkflowIDRef: React.RefObject<any> = React.createRef();

    constructor(props: MyPendingReportsProps) {
        super(props);
        this.state = {
            selectedItem: null,
            showCancelDialog: false,
            showWorkflowIdDialog: false,
            isAdminMode: false,
            pendingReports: null,
            columns: [...this.normalModeColumns, ...this.actionColumns],
            filteredItems: null,
            isShowUpdateWorkflowIdDialog: false,
        };
        this.cancelUpload = this.cancelUpload.bind(this);
    }

    componentDidMount() {
        Helper.runNewTask(() => {
            this.getPendingUploads();
        });
    }

    changeMode() {
        this.setState({
            isAdminMode: !this.state.isAdminMode
        }, () => {
            Helper.runNewTask(async () => {
                await this.getPendingUploads();
            });
        })
    }

    _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
        const key = columnKey as keyof T;
        return items.slice(0).sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
    }

    private _onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
        const { filteredItems } = this.state;
        const newColumns: IColumn[] = this.normalModeColumns.slice();
        const currColumn: IColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
        newColumns.forEach((newCol: IColumn) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });
        const newItems = this._copyAndSort(filteredItems ?? [], currColumn.fieldName!, currColumn.isSortedDescending);
        this.setState({
            columns: newColumns,
            filteredItems: newItems,
        });
    };

    shimmeredDetailsListProps: IListProps = {
        renderedWindowsAhead: 0,
        renderedWindowsBehind: 0,
    };


    normalModeColumns: IColumn[] = [
        {
            key: 'title',
            name: 'Title',
            fieldName: 'Title',
            currentWidth: Helper.resizeColumnByScreenWidth(10),
            minWidth: Helper.resizeColumnByScreenWidth(10),
            isResizable: true,
            isRowHeader: true,
            data: 'string',
            isPadded: true,
            onColumnClick: this._onColumnClick,
            sortAscendingAriaLabel: 'Sorted A to Z',
            sortDescendingAriaLabel: 'Sorted Z to A',
            onRender: (item: IAccountReport) => {
                return (
                    <Link target='_blank' href={Helper.generateAccessMediatorUrl(item.id)}>{item.title}</Link>
                );
            }
        },
        {
            key: 'authors',
            name: 'Author(s)',
            fieldName: 'Authors',
            currentWidth: Helper.resizeColumnByScreenWidth(12),
            minWidth: Helper.resizeColumnByScreenWidth(12),
            isResizable: true,
            isRowHeader: true,
            data: 'string',
            isPadded: true,
            isMultiline: true,
            sortAscendingAriaLabel: 'Sorted A to Z',
            sortDescendingAriaLabel: 'Sorted Z to A',
            onRender: (item: IAccountReport) => {
                const authors = item.author ? item.author.split(",") : [];
                return Template.renderReadOnlyPeople(authors);
            }
        },
        {
            key: 'basicProps',
            name: 'Basic Information',
            fieldName: 'Basic Information',
            currentWidth: Helper.resizeColumnByScreenWidth(15),
            minWidth: Helper.resizeColumnByScreenWidth(15),
            isResizable: true,
            isRowHeader: true,
            data: 'string',
            isPadded: true,
            isMultiline: true,
            onRender: (item: IAccountReport) => {
                return (
                    <>
                        <RbLabel isInline={false} size={LabelSize.Small} >Division: <strong>{item.division}</strong></RbLabel>
                        <RbLabel isInline={false} size={LabelSize.Small} >Department: <strong>{item.department}</strong></RbLabel>
                        <RbLabel isInline={false} size={LabelSize.Small} >Upload Type: <strong>{item.uploadType}</strong></RbLabel>
                    </>
                );
            }
        },
        {
            key: 'keywords',
            name: 'Keywords',
            fieldName: 'Keywords',
            currentWidth: Helper.resizeColumnByScreenWidth(15),
            minWidth: Helper.resizeColumnByScreenWidth(15),
            isResizable: true,
            isRowHeader: true,
            data: 'string',
            isPadded: true,
            onRender: (item: IAccountReport) => {
                return (
                    <TooltipHost
                        directionalHint={DirectionalHint.leftCenter}
                        content={item.keywords}>
                        {item.keywords}
                    </TooltipHost>
                );
            }
        },
    ];

    adminModeColumns: IColumn[] = [
        {
            key: 'submitter',
            name: 'Submitter',
            fieldName: 'Submitter',
            currentWidth: Helper.resizeColumnByScreenWidth(15),
            minWidth: Helper.resizeColumnByScreenWidth(15),
            isResizable: true,
            isRowHeader: true,
            data: 'string',
            isPadded: true,
            onRender: (item: IAccountReport) => {
                return Template.renderReadOnlyPeople([item.createdBy]);
            }
        },
        {
            key: 'correlationId',
            name: 'Correlation ID',
            fieldName: 'CorrelationId',
            currentWidth: Helper.resizeColumnByScreenWidth(8),
            minWidth: Helper.resizeColumnByScreenWidth(8),
            isResizable: true,
            isRowHeader: true,
            data: 'string',
            isPadded: true,
            onRender: (item: IAccountReport) => {
                return (
                    <TooltipHost
                        directionalHint={DirectionalHint.leftCenter}
                        content={item.correlationId}>
                        <RbLabel size={LabelSize.Small} >{item.correlationId}</RbLabel>
                    </TooltipHost>
                );
            }
        }
    ]

    actionColumns: IColumn[] = [
        {
            key: 'workflowId',
            name: 'Workflow ID',
            fieldName: 'WorkflowId',
            currentWidth: Helper.resizeColumnByScreenWidth(10),
            minWidth: Helper.resizeColumnByScreenWidth(10),
            isResizable: true,
            isRowHeader: true,
            data: 'string',
            isPadded: true,
            isMultiline: true,
            onRender: (item: IAccountReport) => {
                return (
                    (this.state.isAdminMode === true) ?
                        <RbButton type={ButtonType.Secondary} onClick={() => this._onClickWorkflowId(item)} size={ButtonSize.Small} label={
                            (item.workflowId !== "" && !_.isNil(item.workflowId)) ?
                                item.workflowId : "N/A"}
                            title="Click here to edit this Workflow ID" />
                        :
                        (item.workflowId !== "" && !_.isNil(item.workflowId)) && 
                        <Link target='_blank' href={process.env.REACT_APP_WORKON_BROWSE + item.workflowId}>
                            {item.workflowId}
                        </Link>
                        || "N/A"
                );
            }
        },
        {
            key: 'cancelUpload',
            name: '',
            fieldName: 'Actions',
            currentWidth: Helper.resizeColumnByScreenWidth(20),
            minWidth: Helper.resizeColumnByScreenWidth(20),
            isResizable: true,
            isRowHeader: true,
            isPadded: true,
            isMultiline: true,
            onRender: (item: IAccountReport) => {
                return (
                    <RbButton label="Cancel Upload" size={ButtonSize.Small} onClick={() => {
                        this.setState({
                            showCancelDialog: true,
                            selectedItem: item
                        })
                    }
                    } />
                );
            }
        }
    ]

    async getPendingUploads() {
        this.setState({
            filteredItems: null
        })
        let pendingReports: IAccountReport[] = []
        try {
            pendingReports.push(...await getPendingUploads(this.state.isAdminMode));
            this.setState({
                pendingReports: pendingReports,
                filteredItems: pendingReports
            })
        } catch (error) {
            this.props.showDialog(false)
        }
    }

    async cancelUpload(reason: string) {
        if (reason !== "") { // OK
            if (!!this.props.userProfile) {
                this.props.showDialog(Constants.DIALOG_MESSAGE.CANCEL_UPLOADED_REPORT);
                try {
                    var request = {
                        reportId: this.state.selectedItem?.id ?? -1,
                        comment: reason
                    } as ICancelRequest
                    let response = await cancelWorkflow(request)
                    if (response.error === false) {
                        this.props.showToastMessage(
                            Constants.TOAST_MESSAGE_CODE.SUCCESS,
                            Constants.CANCEL_REPORT.UPLOAD.SUCCESS
                        );
                        this.getPendingUploads();
                    }
                    else {
                        this.props.showToastMessage(
                            Constants.TOAST_MESSAGE_CODE.ERROR,
                            Constants.CANCEL_REPORT.UPLOAD.FAILED
                        );
                    }
                    this.props.showDialog(false);
                    this.setState({
                        selectedItem: undefined,
                        showCancelDialog: false
                    });
                } catch (error) {
                    this.props.showToastMessage(
                        Constants.TOAST_MESSAGE_CODE.ERROR,
                        Constants.CANCEL_REPORT.UPLOAD.FAILED
                    );
                    this.props.showDialog(false);
                    this.setState({
                        selectedItem: undefined,
                        showCancelDialog: false
                    });
                }
            }
            else {
                this.props.showToastMessage(
                    Constants.TOAST_MESSAGE_CODE.ERROR,
                    "Something went wrong with your permission. Please try again! If the problem persists, Please click the Support button located below your avatar for assistance"
                );
                this.props.showDialog(false);
                this.setState({
                    selectedItem: undefined,
                    showCancelDialog: false
                });
            }
        }
        else { // Cancel
            this.setState({
                selectedItem: undefined,
                showCancelDialog: false
            });
        }
    }

    private _onChangeText = (text: string): void => {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(() => {
            this.setState({
                filteredItems: text ? [...this.state.pendingReports ?? []].filter(i => i.title && i.title.toLowerCase().indexOf(text.toLowerCase()) > -1
                    || i.keywords && i.keywords.toLowerCase().indexOf(text.toLowerCase()) > -1
                    || i.workflowId && i.workflowId.toLowerCase().indexOf(text.toLowerCase()) > -1) : [...this.state.pendingReports ?? []],
            });
        }, 500);
    };

    _onRenderPanelFooterContent = () => {
        return (
            <div>
                <RbButton label="Save" onClick={this._onSaveWorkflowId} />
                <RbButton label="Cancel" type={ButtonType.Secondary} onClick={this._onDismissDialog} />
            </div>
        )
    }

    _onSaveWorkflowId = async () => {
        const { selectedItem } = this.state;
        const newWorkflowID = this.newWorkflowIDRef.current?.getValue() || "";
        if (selectedItem === null || selectedItem.id === undefined || newWorkflowID === selectedItem.workflowId || newWorkflowID === "") {
            this.props.showToastMessage(
                Constants.TOAST_MESSAGE_CODE.ERROR,
                newWorkflowID === "" ? "Workflow ID cannot be empty" : "No changes detected in Workflow ID"
            );
            return;
        }
        const response = await updateWorkflowID(this.state.selectedItem.id, newWorkflowID);
        if (response.success === true) {
            this.props.showToastMessage(
                Constants.TOAST_MESSAGE_CODE.SUCCESS,
                "Workflow ID has been updated successfully"
            );
            this.getPendingUploads();
            this._onDismissDialog();
        }
        else {
            this.props.showToastMessage(
                Constants.TOAST_MESSAGE_CODE.ERROR,
                response.message || "Failed to update Workflow ID"
            );
        }
    }

    _onDismissDialog = () => {
        this.setState({
            isShowUpdateWorkflowIdDialog: false
        })
    }

    _onOpenDialog = () => {
        this.setState({
            isShowUpdateWorkflowIdDialog: true
        })
    }

    _onClickWorkflowId = (item: any) => {
        this.setState({
            selectedItem: item
        })
        this._onOpenDialog();
    }
    render() {
        let { filteredItems, selectedItem } = this.state
        let modeColumns = !!this.state.isAdminMode && [...this.normalModeColumns, ...this.adminModeColumns, ...this.actionColumns] || [...this.normalModeColumns, ...this.actionColumns]
        let element = (
            <div className="ms-Grid">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm1" />
                    <div className="ms-Grid-col ms-sm10">

                        <div className="ms-Grid">
                            <div className="ms-Grid-row">
                                <RbLabel className="header-title" size={LabelSize.Large}> Pending Approval Reports </RbLabel>
                                <ListActionsMenu
                                    columns={modeColumns}
                                    items={filteredItems || []}
                                    searchText={(value: any) => { this._onChangeText(value) }}
                                    showAdminResults={this.state.isAdminMode}
                                    getAdminData={() => {
                                        this.changeMode();
                                    }}></ListActionsMenu>
                            </div>
                            <DetailsListWrapper>
                                <ShimmeredDetailsList
                                    setKey="set"
                                    compact={true}
                                    items={filteredItems || []}
                                    constrainMode={ConstrainMode.unconstrained}
                                    columns={modeColumns}
                                    selectionMode={SelectionMode.single}
                                    enableShimmer={!filteredItems}
                                    ariaLabelForShimmer="Content is being fetched"
                                    ariaLabelForGrid="Pending report detail"
                                    listProps={this.shimmeredDetailsListProps}
                                    onRenderDetailsHeader={Configuration.onRenderStickyDetailsHeader}
                                    onShouldVirtualize={() => { return true }}
                                />
                            </DetailsListWrapper>
                        </div>

                    </div>
                    <div className="ms-Grid-col ms-sm1" />
                </div>
                {/* Cancel dialog */}
                {(this.state.showCancelDialog === true) ? <CancelReasonDialog closeDialog={this.cancelUpload}></CancelReasonDialog> : ""}
                <Panel
                    customWidth='600px'
                    isLightDismiss
                    isOpen={this.state.isShowUpdateWorkflowIdDialog}
                    onDismiss={this._onDismissDialog}
                    closeButtonAriaLabel="Close"
                    headerText="Update Workflow ID"
                    isFooterAtBottom
                    onRenderFooterContent={this._onRenderPanelFooterContent}
                >
                    Current ID: {(selectedItem?.workflowId !== "" && !_.isNil(selectedItem?.workflowId)) ? selectedItem?.workflowId : "Empty"}
                    <RbDivider />
                    <RbTextField label="Workflow ID" placeholder="Enter new Workflow ID" ref={this.newWorkflowIDRef} />
                </Panel >
            </div >
        );
        return element;
    }
}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile,
});

export default connect(mapStateToProps, {
    showDialog,
    showToastMessage,
})(MyPendingReports);